import styles from './ErrorMessage.module.css';

export default function ErrorMessage({ error, onClose, width }) {
	if (!error) return null;

	return (
		<div
			className={styles.error}
			style={width ? { width } : undefined}
			onClick={onClose}
			role="alert"
		>
			<span className={styles.errorText}>{error}</span>
			<span
				className={styles.errorClose}
				onClick={(e) => {
					e.stopPropagation();
					onClose?.();
				}}
				aria-label="Close error"
			>
				✖
			</span>
		</div>
	);
}
